import ResultsListItem from './results-list-item'
import { ResultsListGrid } from './results-list.style'

const ResultsList = () => {
    return (
        <>
            <ResultsListGrid>
                <ResultsListItem subject="English Language" time="2 hours ago" score="59/100" />
                <ResultsListItem subject="Mathematics" time="4 hours ago" score="80/100" />
                <ResultsListItem subject="Health Education" time="9 hours ago" score="62/100" />
                <ResultsListItem subject="Physics" time="1 week ago" score="75/100" />
                <ResultsListItem subject="Biology" time="9 hours ago" score="85/100" />
                <ResultsListItem subject="Computer Science" time="1 week ago" score="99/100" />
            </ResultsListGrid>
        </>
    )
}

export { ResultsList }
